import React, { useState, useEffect } from 'react';
import { Spin, Alert } from 'antd';
import { WifiOutlined } from '@ant-design/icons';
import { probeLatency, assessQuality, subscribeToNetworkChanges } from '../utils/networkQuality';

const QUALITY_CONFIG = {
  good:       { label: 'Dobra konekcija',        alertType: null },
  moderate:   { label: 'Osrednja konekcija',     alertType: 'warning' },
  fair:       { label: 'Slaba konekcija',        alertType: 'warning' },
  poor:       { label: 'Jako slaba konekcija',   alertType: 'error' },
  datasaver:  { label: 'Štednja podataka',       alertType: 'warning' },
};

const QUALITY_MESSAGES = {
  moderate: 'Sinhronizacija može biti sporija nego inače.',
  fair:     'Konekcija je slaba. Sinhronizacija može trajati duže ili biti nestabilna.',
  poor:     'Konekcija je jako slaba. Preporučujemo čekanje boljeg signala ili WiFi-a prije sinhronizacije.',
  datasaver:'Uključena je štednja podataka. Sinhronizacija može biti ograničena.',
};

const formatDetail = (rtt, downlink, effectiveType) => {
  const parts = [];
  if (effectiveType) parts.push(effectiveType.toUpperCase());
  if (downlink != null) parts.push(`${downlink} Mbps`);
  if (rtt != null) parts.push(`${rtt}ms`);
  return parts.join(' · ');
};

const NetworkQualityBanner = ({ visible }) => {
  const [quality, setQuality] = useState(null);
  const [probing, setProbing] = useState(false);

  useEffect(() => {
    if (!visible) return;

    let mounted = true;

    const probe = async () => {
      setProbing(true);
      const rtt = await probeLatency();
      if (mounted) {
        setQuality(assessQuality(rtt));
        setProbing(false);
      }
    };

    probe();

    const unsub = subscribeToNetworkChanges(async () => {
      const rtt = await probeLatency();
      if (mounted) setQuality(assessQuality(rtt));
    });

    return () => {
      mounted = false;
      unsub();
    };
  }, [visible]);

  if (!visible) return null;

  if (probing) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '8px 0', color: '#8c8c8c', fontSize: 13 }}>
        <Spin size="small" />
        Provjera konekcije...
      </div>
    );
  }

  if (!quality) return null;

  const config = QUALITY_CONFIG[quality.level];
  const detail = formatDetail(quality.rtt, quality.downlink, quality.effectiveType);
  const message = QUALITY_MESSAGES[quality.level];

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6, marginBottom: message ? 6 : 0 }}>
        <WifiOutlined style={{ color: quality.color, fontSize: 14 }} />
        <span style={{ color: quality.color, fontWeight: 500, fontSize: 13 }}>
          {config.label}
        </span>
        {detail && (
          <span style={{ color: '#8c8c8c', fontSize: 12 }}>
            · {detail}
          </span>
        )}
      </div>
      {message && (
        <Alert
          type={config.alertType}
          message={message}
          showIcon={false}
          style={{ fontSize: 12, padding: '4px 10px' }}
        />
      )}
    </div>
  );
};

export default NetworkQualityBanner;
